import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../constants/common'
import Button, { BUTTON_HEIGHT_24 } from '../../Button'
import { useEmailFilesDownloadAll } from '../../Email'
import Text from '../../Text'

import * as styles from './FileListDownloadAll.module.css'

import DownloadIcon from '../../../icons/export.svg'

function FileListDownloadAll({
  className = styles.FileListDownloadAll,
  downloadButtonProps: {
    beforeIconProps: {
      Icon: downloadButtonBeforeIcon = DownloadIcon,
      tooltip:
        downloadButtonBeforeTooltip = 'FilesGallery.DownloadAttachedFilesBtnTooltipKey',
      ...beforeIconProps
    } = EMPTY_OBJECT,
    height: downloadButtonBeforeHeight = BUTTON_HEIGHT_24,
    text: downloadButtonBeforeText = 'FilesGallery.DownloadAttachedFilesBtnKey',
    ...downloadButtonProps
  } = EMPTY_OBJECT,
  files,
}) {
  const { t } = useTranslation()

  const { handleClickDownloadAll, modal } = useEmailFilesDownloadAll({
    files,
  })

  return (
    <div className={className}>
      <Text isSecondary>
        {t('FilesGallery.AttachedFilesCount', { count: files.length })}
      </Text>
      <Button.Text
        {...downloadButtonProps}
        beforeIconProps={{
          ...beforeIconProps,
          Icon: downloadButtonBeforeIcon,
          tooltip: t(downloadButtonBeforeTooltip),
        }}
        height={downloadButtonBeforeHeight}
        text={t(downloadButtonBeforeText)}
        onClick={handleClickDownloadAll}
      />
      {modal}
    </div>
  )
}

export default FileListDownloadAll
